// English.
const en = {
  "common.loading": "Loading…",
  "common.back": "Back",
  "common.continue": "Continue",
  "common.start": "Start",
  "common.review": "Review",
  "common.watchAgain": "Watch again",
  "common.read": "Read",
  "common.understood": "Got it",
  "common.retry": "Try again",
  "common.save": "Save",
  "common.saving": "Saving…",
  "common.close": "Close",
  "common.demo": "Demo environment · fictional data",
  "common.language": "Language",

  "nav.home": "Home",
  "nav.dashboard": "Dashboard",
  "nav.profile": "Profile",
  "nav.certificates": "My certificates",
  "nav.logout": "Log out",
  "nav.openMenu": "Open menu",
  "nav.lesson": "Lesson",
  "nav.learningWorlds": "Learning worlds",
  "nav.controlPanel": "Control panel",
  "nav.badges": "Badges earned",
  "nav.seeBadges": "See my badges",

  "login.title": "Sign in",
  "login.email": "Email",
  "login.password": "Password",
  "login.submit": "Sign in",
  "login.noAccount": "Don't have an account?",
  "login.register": "Sign up",
  "login.general": "Go to the general login",
  "login.orgNotFound": "Organization not found",
  "login.error": "We couldn't sign you in. Check your email and password.",
  "login.googleError": "We couldn't sign you in with Google.",
  "login.goToOrg": "Go to {org} login",
  "login.yourOrg": "your organization",

  "home.welcome": "Welcome to {org}",
  "home.noChallenges": "You don't have any learning paths assigned yet.",
  "home.myChallenges": "My challenges",
  "home.pick": "Pick a learning path to start.",
  "home.pickOrg": "{org}: pick a learning path to start.",
  "home.loading": "Loading…",
  "home.loadingHint": "We're preparing your learning experience.",
  "home.loadingCourse": "Loading course…",
  "home.loadingCourseHint": "Fetching modules, lessons and your latest progress.",
  "home.loadingLessons": "Loading lessons…",
  "home.loadingLessonsHint": "One moment, we're laying out the course map.",
  "home.loadingChallenges": "Loading available courses…",
  "home.loadingChallengesHint": "Looking for your paths, progress and ranking.",
  "home.courseError": "We couldn't load the course",
  "home.courseErrorHint": "We couldn't load the course. Check your connection and try again.",
  "home.map": "Learning map",
  "home.backToChallenges": "Back to paths",
  "home.overallProgress": "Overall progress",
  "home.stages": "{done}/{total} modules",
  "home.points": "pts",
  "home.lessons": "{done}/{total} lessons",
  "home.stage": "Module",
  "home.locked": "Locked",
  "home.completed": "Completed",
  "home.inProgress": "In progress",
  "home.pending": "Pending",
  "home.certifies": "Certifies",

  "task.startQuiz": "Start assessment",
  "task.startExercise": "Start exercise",
  "task.startSimulation": "Start simulation",
  "task.watch": "Watch",
  "task.minutes": "{n} min",

  "lesson.backHome": "Back to home",
  "lesson.backToMap": "Back to map",
  "lesson.finishTitle": "Finish this lesson",
  "lesson.finishHint": "To move on, first save your progress in the current lesson.",
  "lesson.resourceOf": "Resource {n} of {total}",
  "lesson.saved": "Your progress is saved.",
  "lesson.saveWhenDone": "When you finish the activity, save your progress.",
  "lesson.saveWhenDoneLong": "When you finish the activity, save your progress to continue.",
  "lesson.next": "Continue with the next resource.",
  "lesson.nextLong": "Continue with the next resource of this lesson.",
  "lesson.nextResource": "Next resource",
  "lesson.finish": "Finish lesson",
  "lesson.rate": "Rate this lesson",
  "lesson.rateHint": "Your feedback helps us improve.",
  "lesson.loading": "Loading lesson",
  "lesson.congrats": "Congratulations!",
  "lesson.challengeDone": "Congratulations! You completed the path!",
  "lesson.scormActive": "SCORM 1.2 active",

  "exam.title": "Assessment",
  "exam.loading": "Loading assessment…",
  "exam.loadError": "We couldn't load this assessment. Try again.",
  "exam.sessionError": "We couldn't load the assessment: session or path data is missing.",
  "exam.saveError": "We couldn't save the assessment result.",
  "exam.passed": "Assessment passed",
  "exam.saved": "Result saved",
  "exam.score": "You got {correct}/{total} correct ({pct}%).",
  "exam.needed": "You need at least {n} correct answers to pass. Review the content and try again.",
  "exam.readyToSend": "Ready to submit.",
  "exam.answerAll": "Answer every question to submit the assessment.",
  "exam.submit": "Submit assessment",
  "exam.retry": "Try again",
  "exam.backToMap": "Back to map",
  "exam.question": "Question {n} of {total}",
  "exam.seeCertificate": "See my certificate",
  "exam.passingScoreHint": "Passing score: {n} correct answers out of {total}.",

  "cert.title": "Certificate",
  "cert.certifies": "This certifies that",
  "cert.completed": "successfully completed",
  "cert.issuedOn": "Issued on {date}",
  "cert.validUntil": "Valid until {date}",
  "cert.code": "Verification code",
  "cert.score": "Score: {pct}%",
  "cert.print": "Print or save as PDF",
  "cert.mine": "My certificates",
  "cert.none": "You don't have certificates yet. Pass a certifiable assessment and it will show up here.",
  "cert.view": "View certificate",
  "cert.verify": "Verify at {url}",
  "cert.signedBy": "Signature",
  "cert.expired": "Expired",
  "cert.valid": "Valid",
  "cert.expiring": "Expiring soon",

  "profile.myData": "My data",
  "profile.organization": "Organization",
  "profile.badges": "My badges",

  // Aclara theme (Campus Aclara)
  "aclara.status.done": "Completed",
  "aclara.status.progress": "In progress",
  "aclara.status.pending": "Pending",
  "aclara.nav.route": "My path",
  "aclara.nav.news": "News",
  "aclara.nav.certificates": "Certificates",
  "aclara.nav.dashboard": "Dashboard",
  "aclara.nav.profile": "Profile",
  "aclara.role.admin": "Administration",
  "aclara.role.collaborator": "Team member",
  "aclara.footer.campus": "Onboarding campus",
  "aclara.footer.powered": "Ewaffle learning platform",
  "aclara.login.eyebrow": "Onboarding",
  "aclara.login.claim": "Your first week at Aclara starts here.",
  "aclara.login.claimBody": "Six short modules to get to know the company, how we care for people and the environment, and how we work as a team. On your phone, in your language.",
  "aclara.login.metaModules": "modules",
  "aclara.login.metaCountries": "countries",
  "aclara.login.metaCerts": "certificates",
  "aclara.login.title": "Campus Aclara",
  "aclara.login.welcome": "Sign in with your company email.",
  "aclara.login.or": "or",
  "aclara.home.eyebrow": "Campus",
  "aclara.home.hello": "Hi, {name}",
  "aclara.home.intro": "Your onboarding path: short modules, two certifiable assessments and a certificate when you finish.",
  "aclara.home.seeRoute": "See my path",
  "aclara.home.seeCertificates": "See my certificates",
  "aclara.home.routeDone": "Path completed",
  "aclara.home.routeDoneHint": "You finished onboarding. Your certificates are ready.",
  "aclara.home.lessonsDone": "{done} of {total} lessons",
  "aclara.home.nextIs": "Up next: {name}",
  "aclara.home.loadingRoute": "Loading your path…",
  "aclara.home.modulesEyebrow": "Your path",
  "aclara.home.newsTitle": "Latest at Aclara",
  "aclara.home.allNews": "All news",
  "aclara.home.allCerts": "See all",
  "aclara.news.eyebrow": "News",
  "aclara.news.title": "News",
  "aclara.news.intro": "Company and country updates. Whatever the People team publishes shows up here.",
  "aclara.news.none": "No news published yet.",
  "aclara.module.lessonsCount": "{done}/{total} lessons",
  "aclara.module.certifies": "Certifies",
  "aclara.module.n": "Module {n}",
  "aclara.module.notFound": "We couldn't find this module in your path.",
  "aclara.module.contents": "Module contents",
  "aclara.module.certHint": "Passing «{title}» issues a certificate valid for 12 months. You can retake the assessment as many times as you need.",
  "aclara.lesson.kindLesson": "Lesson",
  "aclara.lesson.kindExam": "Assessment",
  "aclara.lesson.notFound": "We couldn't find this lesson in your path.",
  "aclara.lesson.noResource": "This lesson has no content loaded yet.",
  "aclara.lesson.status": "Status",
  "aclara.lesson.scormHint": "Progress is saved when you finish the content. If you already went through it all, mark it here.",
  "aclara.lesson.markDone": "Mark as completed",
  "aclara.lesson.adminPreview": "Admin preview: progress is only recorded for team members.",
  "aclara.lesson.prev": "Previous",
  "aclara.lesson.next": "Next",
  "aclara.lesson.module": "See module",
  "aclara.exam.notYet": "Not yet",
  "aclara.exam.backToRoute": "Back to my path",
  "aclara.certs.intro": "The certificates you earn by passing an assessment. Each one has a code anyone can verify.",
  "aclara.profile.noBadges": "No badges yet. Complete your first lesson to earn the first one.",
  "aclara.dash.openAdmin": "Open admin tools",
  "aclara.dash.title": "Progress by {label}",
  "aclara.dash.intro": "How many people are enrolled, how many finished the path and how many certificates were issued, by country.",
  "aclara.dash.noSegment": "No {label}",
  "aclara.dash.kpiTotal": "People",
  "aclara.dash.kpiEnrolled": "Enrolled",
  "aclara.dash.kpiDone": "Completed",
  "aclara.dash.kpiCerts": "Certificates",
  "aclara.dash.bySegment": "Summary by {label}",
  "aclara.dash.empty": "No data to show yet.",
  "aclara.dash.completion": "Completed / enrolled",
  "aclara.dash.progressBy": "Path progress by {label}",
  "aclara.dash.bucket.done": "Completed",
  "aclara.dash.bucket.mid": "In progress",
  "aclara.dash.bucket.none": "Not started",
  "aclara.dash.people": "{n} people",
  "aclara.dash.avgProgress": "Average progress",
  "aclara.dash.avgGrade": "Average grade",
  "aclara.dash.loggedIn": "Signed in",
};

export default en;
